module.exports = __webpack_public_path__ + "static/media/EXPORT_BULK_UPLOAD_3.00.f110b65d.xlsx";